export const SET_STATE = 'checkoutPage/paymentAdyen/SET_STATE';
export const SET_FETCHING_PAYMENT = 'checkoutPage/paymentAdyen/SET_FETCHING_PAYMENT';
export const SET_PAYMENT_DATA = 'checkoutPage/paymentAdyen/SET_PAYMENT_DATA';
export const SET_PAYMENT_RESPONSE = 'checkoutPage/paymentAdyen/SET_PAYMENT_RESPONSE';
export const SET_ADDITIONAL_DETAILS = 'checkoutPage/paymentAdyen/SET_ADDITIONAL_DETAILS';
export const RESET_STATE = 'checkoutPage/paymentAdyen/RESET_STATE';
 